import { render, staticRenderFns } from "./DetailKasbonExternal.vue?vue&type=template&id=386574d7"
import script from "./DetailKasbonExternal.vue?vue&type=script&lang=js"
export * from "./DetailKasbonExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports